export const navigateTo = (url: string): void => {
	window.location.href = url;
};
